import axios from 'axios';

function errorHandler(error, reject) {
    if (error.response && error.response.data) {
        reject(error.response.data);
    } else {
        reject(error);
    }
}

export default {
    list(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                const keys = ['page', 'limit', 'sortBy', 'sortDir', 'catgid', 'category', 'catgname', 'nomorpo', 'outstand', 'asetid', 'asdesc', 'asmodel','asserial', 'asuser', 'aslocat', 'tgl1', 'tgl2', 'DimCol', 'DimColInfo', 'DimVal'];
                let str = '';
                for (const key in obj) {
                    if (keys.indexOf(key) >= 0 && obj[key]) {
                        str += str ? '&' : '?';
                        str += key + '=' + encodeURIComponent(obj[key]);
                    }
                }
                const url = `/fixedasset${str}`;
                const { data } = await axios.get(url);
                const { meta, list } = data;
                obj.total = meta.total;
                resolve(list);
            } catch (error) {
                errorHandler(error, reject);
            }
        });
    },
    listchild(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                const keys = ['page', 'limit', 'sortBy', 'sortDir', 'asetkey'];
                let str = '';
                for (const key in obj) {
                    if (keys.indexOf(key) >= 0 && obj[key]) {
                        str += str ? '&' : '?';
                        str += key + '=' + encodeURIComponent(obj[key]);
                    }
                }
                const url = `/fixedasset/childs${str}`;
                const { data } = await axios.get(url);
                const { meta, list } = data;
                obj.total = meta.total;
                resolve(list);
            } catch (error) {
                errorHandler(error, reject);
            }
        });
    },
    uploadlabel(fileXlsx,obj) {
        return new Promise(async (resolve, reject) => {
            try {
                const fd = new FormData();
                fd.append('fileXlsx', fileXlsx, fileXlsx.name);
                for (const key in obj) {
                        fd.append(key, obj[key]);
                }
                const { data } = await axios.post("fixedasset/uploadlabel", fd);
                resolve(data);
            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },
    save(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                const {data} = await axios.post('/fixedasset', obj);
                resolve(data);
            } catch (error) {
                errorHandler(error, reject);
            }
        });
    },
    savegainfo(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                const {data} = await axios.post('/fixedasset/gainfo', obj);
                resolve(data);
            } catch (error) {
                errorHandler(error, reject);
            }
        });
    },
    savechild(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                const {data} = await axios.post('/fixedasset/child', obj);
                resolve(data);
            } catch (error) {
                errorHandler(error, reject);
            }
        });
    },    
    remove(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                const resp = await axios.delete(`/fixedasset/${obj.asetkey}`);
                resolve(resp);
            } catch (error) {
                errorHandler(error, reject);
            }
        })
    },
    removechild(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                const resp = await axios.delete(`/fixedasset/child/${obj.asetChildKey}`);
                resolve(resp);
            } catch (error) {
                errorHandler(error, reject);
            }
        })
    },
    detail(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                const { data } = await axios.get(`/fixedasset/detail/${obj.asetkey}`);
                resolve(data);
            } catch (error) {
                errorHandler(error, reject);
            }
        });
    },
    detailga(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                const { data } = await axios.get(`/fixedasset/detailga/${obj.asetkey}`);
                resolve(data);
            } catch (error) {
                errorHandler(error, reject);
            }
        });
    },
    print(obj = {}) {
        return new Promise(async (resolve, reject) => {
            let url;
            let str = '';
            try {
                str = '?key=' + encodeURIComponent(obj.asetkey);
                url = `/fixedasset/print`;

                url += str;
                const { data } = await axios.get(url);
                const link = `${process.env.VUE_APP_BASE_API}/printpreview/pdf/${data.id}`
                resolve(link);
            } catch (error) {
                errorHandler(error, reject)
            }
        });
    }, 
    printAcc(obj = {}) {
        return new Promise(async (resolve, reject) => {
            let url;
            let str = '';
            try {
                str = '?key=' + encodeURIComponent(obj.asetkey);
                url = `/fixedasset/printacc`;

                url += str;
                const { data } = await axios.get(url);
                const link = `${process.env.VUE_APP_BASE_API}/printpreview/pdf/${data.id}`
                resolve(link);
            } catch (error) {
                errorHandler(error, reject)
            }
        });
    }, 
    exportxls(obj = {}) {
        return new Promise(async(resolve, reject) => {
            try {
                const keys = ['expMode', 'sortBy', 'sortDir', 'catgid', 'category', 'catgname', 'nomorpo', 'outstand', 'asetid', 'asdesc', 'asmodel', 'asserial', 'asuser', 'aslocat', 'tgl1', 'tgl2', 'DimCol', 'DimColInfo', 'DimVal'];
                let str = '';
                for (const key in obj) {
                    if (keys.indexOf(key) >= 0 && obj[key]) {
                        str += str ? '&' : '?';
                        str += key + '=' + encodeURIComponent(obj[key]);
                    }
                }

                const response = await axios({
                    url:`/fixedasset/exportxls${str}`,
                    method: 'GET',
                    responseType: 'blob', // important
                });
                resolve(response);

                // axios({
                //     url: `/fixedasset/exportxls${str}`,
                //     method: 'GET',
                //     responseType: 'blob', // important
                // }).then((response) => {
                //     const url = window.URL.createObjectURL(new Blob([response.data]));
                //     const link = document.createElement('a');
                //     link.href = url;
                //     link.setAttribute('download', 'Fixed_asset_list.xlsx');
                //     document.body.appendChild(link);
                //     link.click();
                //     // window.location.assign(url);
                //     resolve(link);
                // });

            } catch (error) {
                let responseObj = await error.response.data.text();
                errorHandler(JSON.parse(responseObj), reject);
            }
        });
    },
    token() {
        return new Promise(async (resolve, reject) => {
            try {
                const APP_AUTH_TK = process.env.VUE_APP_AUTH_TK;
                const data = JSON.parse(localStorage.getItem(APP_AUTH_TK));
                data.baseURL = process.env.VUE_APP_BASE_API;
                data.headers = { 'authorization': data.token };
                resolve(data);
            } catch (error) {
                errorHandler(error, reject);
            }
        });

    },
    images(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                const { data } = await axios.get(`/fixedasset/images/${obj.asetkey}`);
                resolve(data);
            } catch (error) {
                errorHandler(error, reject);
            }
        });
    },
    deleteimage(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                const { data } = await axios.delete(`/fixedasset/delete-image/${obj.imgKey}`);
                resolve(data);
            } catch (error) {
                errorHandler(error, reject);
            }
        });
    },
    category() {
        return new Promise(async (resolve, reject) => {
            try {
                const { data } = await axios.get(`/fixedasset/category`);
                resolve(data);
            } catch (error) {
                errorHandler(error, reject);
            }
        });
    },
    currency() {
        return new Promise(async (resolve, reject) => {
            try {
                const {
                    data
                } = await axios.get("/currency/cbo");
                resolve(data);
            } catch (error) {
                errorHandler(error, reject)
            }
        })
    }

};